<template>
    <div>
        <h2>{{$t('CHANGE_PASSWORD')}}</h2>
        <hr>

        <div v-if="response.success !== null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span>{{$t('OLD_PASSWORD')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="passwordChange.oldPassword" type="password" class="form-control" />
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span>{{$t('NEW_PASSWORD')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="passwordChange.newPassword" type="password" class="form-control" />
                </div>
            </div>
            <div class="input-group mb-3">
                <div class="col-12">
                    <span>{{$t('REPEAT_NEW_PASSWORD')}}</span>
                </div>
                <div class="col-5">
                    <input v-model="passwordChange.newPasswordRepeated" type="password" class="form-control" />
                </div>
            </div>
            <div class="form-group">
                <div class="col-5">
                    <button @click="editDoctorProfile()" class="btn btn-primary">{{$t('CHANGE')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
    data() {
        return {
            passwordChange :
            {
                "oldPassword": "",
                "newPassword": "",
                "newPasswordRepeated": ""
            },
            response: {
                success: null,
                message: ""
            }
        }
    },
    methods: {
        editDoctorProfile: function(){
            let self = this;
            this.$http.post("/api/users/change-password", this.passwordChange)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        }
    },
    watch: {
        response: function(val){
            setTimeout(() => {this.response.success = null}, 3000)
        }
    }
}
</script>
<style scoped lang="scss">
    span.input-group-text {
        width: 200px !important;
    }
</style>